import React from 'react'
import Meta from '../components/common/Meta'
import { Services, Testimonial, Footer } from '../components'

function ServicesPage() {
  return (
    <div>
      {/* Modern Page Header with Background Image */}
      <Meta
        title="Our Services | Architecture, Engineering & Construction"
        description="Architectural design, structural engineering, MEP design, interior design, green building, renovation, and turnkey construction services in Rwanda."
        keywords="
            Architectural design services Rwanda, Architects in Kigali,
            Modern house design Rwanda, Residential & commercial building design,
            Architectural drawings services, Interior design Rwanda,
            Residential building design, Commercial architecture services,
            Interior finishing works Kigali, Modern interiors,
            Residential interior solutions,
            Cabinet d’architecture à Kigali, Conception architecturale moderne,
            Plans de maisons modernes, Architecture résidentielle et commerciale,
            Aménagement intérieur Rwanda,
            Serivisi zo gushushanya inzu, Igishushanyo cy’inzu igezweho,
            Ibishushanyo mbonera by’amazu, Inzu,
            Engineering consulting services Rwanda, Structural engineering Rwanda,
            Structural engineers Kigali, Civil engineering consultants,
            Building services engineering, MEP design services Rwanda,
            Electrical and plumbing design Kigali,
            Ingénierie structurelle Rwanda,
            Conception MEP (électricité & plomberie),
            Études techniques du bâtiment, Ingénieurs civils au Rwanda,
            Ubwubatsi bw’imiterere y’inzu (structure),
            Serivisi z’amashanyarazi n’amazi mu nyubako,
            Ubujyanama mu by’ubwubatsi"
      />

      <header
        className="relative bg-cover bg-center min-h-[320px] flex items-center justify-center"
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>

        {/* Content */}
        <div className="relative text-center px-4 z-10">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white uppercase tracking-wide">
            Our Services
          </h1>
          <p className="mt-4 text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            We provide a range of innovative solutions to help you succeed.
          </p>
        </div>
      </header>

      <Services />
      <Testimonial />
      <Footer />
    </div>
  )
}

export default ServicesPage
